import { aiAnalysisConfigSchema } from './config-schema.js';

export const aiAnalysisDefinition = {
  type: 'ai-analysis',
  nameKey: 'nodes.aiAnalysis.name',
  subtitleKey: 'nodes.aiAnalysis.subtitle',
  modalTitleKey: 'nodes.aiAnalysis.title',
  icon: 'auto_awesome',
  color: '#8B5CF6',
  colorGradient: 'linear-gradient(135deg, #A78BFA, #7C3AED)',
  category: 'builtIn',
  schema: aiAnalysisConfigSchema
};
